var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTelegram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.1074 1.0627C29.4695 1.32159 29.6176 1.66682 29.5517 2.09826L25.3381 26.9521C25.2832 27.265 25.1076 27.5077 24.8114 27.6802C24.6577 27.7666 24.4877 27.8097 24.301 27.8097C24.1803 27.8097 24.0487 27.7828 23.906 27.7289L15.2316 24.2499L10.3266 29.5411C10.1291 29.7676 9.87122 29.8808 9.55302 29.8808C9.39935 29.8808 9.27317 29.8593 9.17448 29.8161C8.96597 29.7407 8.80131 29.6139 8.68062 29.4359C8.55994 29.258 8.4996 29.061 8.4996 28.8452V21.5316L0.730522 18.4087C0.324508 18.2576 0.105055 17.9609 0.0721357 17.5186C0.0392164 17.098 0.214782 16.7798 0.598845 16.564L27.9881 1.03027C28.3721 0.803811 28.7452 0.81462 29.1074 1.0627ZM23.4781 25.3179L27.1157 3.9105L3.51223 17.2922L9.0428 19.5089L23.2476 9.16926L15.3798 22.0654L23.4781 25.3179Z",
    fill: "#3E4958"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.38d18674c4239d8a54f03c59feee7f8e.svg";
export { ForwardRef as ReactComponent };